// extracted by mini-css-extract-plugin
export default {"cartbtn_area":"CartBtnArea_cartbtn_area__tqjoc","delete_btn":"CartBtnArea_delete_btn__jyKh6","count_area":"CartBtnArea_count_area__COE2J","piece":"CartBtnArea_piece__EdzXr"};